import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Vhwhite from "../assets/images/Vhwhite";

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer
      id="footer"
      className="footer--new vh-footer"
      itemScope
      itemType="https://schema.org/WPFooter"
    >
      <div className="vh-footer__main">
        <div className="container-n vh-footer__inner">
          <div className="vh-footer__grid">
            <div className="vh-footer__brand">
              <div
                className="vh-footer__logo"
                role="img"
                aria-label="VizHacks"
              >
                <Vhwhite aria-hidden />
              </div>
              <p className="vh-footer__tagline description-n">{t("footer.tagline")}</p>
            </div>

            <div className="vh-footer__block">
              <p className="vh-footer__heading">{t("footer.contactTitle")}</p>
              <address className="vh-footer__address">
                {t("footer.addressLine1")}
                <br />
                {t("footer.addressLine2")}
                <br />
                {t("footer.addressLine3")}
                <br />
                {t("footer.addressLine4")}
                <br />
                {t("footer.addressLine5")}
              </address>
              <Link className="vh-footer__cta" to="/#contact-us">
                {t("footer.contactLink")}
              </Link>
            </div>

            <div className="vh-footer__block vh-footer__block--aside">
              <div className="vh-footer__follow">
                <p className="vh-footer__heading">{t("footer.followTitle")}</p>
                <ul className="vh-footer__social social">
                  <li className="social__item">
                    <a
                      className="social__link"
                      href="https://www.facebook.com/VizHacks"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      aria-label="Facebook"
                    >
                      <svg
                        width="8"
                        height="15"
                        viewBox="0 0 8 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          d="M5.38917 14.8396V7.58559H7.3916L7.65697 5.08581H5.38917L5.39257 3.83464C5.39257 3.18266 5.45452 2.83332 6.39095 2.83332H7.64279V0.333252H5.64008C3.23449 0.333252 2.38779 1.54592 2.38779 3.58523V5.08609H0.888306V7.58587H2.38779V14.8396H5.38917Z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                  </li>
                  <li className="social__item">
                    <a
                      className="social__link"
                      href="https://twitter.com/VizHacks"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      aria-label="X (Twitter)"
                    >
                      <svg
                        width="16"
                        height="14"
                        viewBox="0 0 16 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          d="M12.1171 0.333252H14.379L9.43744 5.98111L15.2508 13.6666H10.699L7.13385 9.00539L3.05453 13.6666H0.791282L6.07675 7.62556L0.5 0.333252H5.16735L8.38991 4.59376L12.1171 0.333252ZM11.3232 12.3127H12.5766L4.48632 1.61599H3.14137L11.3232 12.3127Z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>

              <p className="vh-footer__heading vh-footer__heading--spaced">
                {t("footer.legalTitle")}
              </p>
              <ul className="vh-footer__legal">
                <li>
                  <Link to="/terms-of-use">{t("footer.terms")}</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">{t("footer.privacy")}</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="vh-footer__bottom">
        <p className="vh-footer__copyright description-n">
          {t("footer.copyright", { year })}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
